import { WprBaseValueModeSetter } from './WprBaseValueModeSetter';
import { IWprModeValue } from '../inter/IWprModeValue';
import { WprBaseViewMode } from '../WprBaseViewMode';
import { IWprConfigModeOption } from '../inter/IWprConfigModeOption';

/**
 * placeholder値設定
 */
export class WprPlaceholderModeSetter extends WprBaseValueModeSetter<IWprModeValue> {
	// コンストラクタ  -----------------------------------------------------------
	public constructor(option: IWprConfigModeOption, viewMoode: WprBaseViewMode) {
		super('value', option, viewMoode);
	}
	// --------------------------------------------------------------------------

	// override メソッド	-----------------------------------------------------
	/**
	 * 初期化処理
	 * @param option モード定義オプション
	 */
	public initialize(): void {
		this.initializeModeList(this.option.placeholder);
	}

	/**
	 * コントロールステータス設定処理
	 * @param vinfo 値情報
	 */
	public setControlStatus(vinfo: IWprModeValue): void {
		this.controlInfo.placeholder = vinfo.value;
	}
	// --------------------------------------------------------------------------
}
